import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const DiscoverSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$discoverSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$discoverSection' });

  const slides = [
    {
      id: 1,
      title: t('firstSlideTitle'),
      description: t('firstSlideDescription'),
      imageSrc:
        'images/homePage/discoverSection/luxury-collection-mercedes-salazar-home-collection.jpg',
      link: tLink('firstSlideLink'),
      stackPosition: 'left',
    },
    {
      id: 2,
      title: t('secondSlideTitle'),
      description: t('secondSlideDescription'),
      imageSrc: 'images/homePage/discoverSection/luxury-collection-chufy-peru-collection.jpg',
      link: tLink('secondSlideLink'),
      stackPosition: 'right',
    },
    {
      id: 3,
      title: t('thirdSlideTitle'),
      description: t('thirdSlideDescription'),
      imageSrc: 'images/homePage/discoverSection/luxury-collection-lingua-franca.jpg',
      link: tLink('thirdSlideLink'),
      stackPosition: 'left',
    },
    {
      id: 4,
      title: t('fourthSlideTitle'),
      description: t('fourthSlideDescription'),
      imageSrc: 'images/homePage/discoverSection/luxury-collection-assouline-collection.jpg',
      link: tLink('fourthSlideLink'),
      stackPosition: 'right',
    },
    {
      id: 5,
      title: t('fifthSlideTitle'),
      description: t('fifthSlideDescription'),
      imageSrc: 'images/homePage/discoverSection/luxury-collection-chufy-kimono.jpg',
      link: tLink('fifthSlideLink'),
      stackPosition: 'left',
    },
    {
      id: 6,
      title: t('sixthSlideTitle'),
      description: t('sixthSlideDescription'),
      imageSrc: 'images/homePage/discoverSection/luxury-collection-globe-trotter-luggage.jpg',
      link: tLink('sixthSlideLink'),
      stackPosition: 'right',
    },
    {
      id: 7,
      title: t('seventhSlideTitle'),
      description: t('seventhSlideDescription'),
      imageSrc: 'images/homePage/discoverSection/luxury-collection-missoni-backpack.jpg',
      link: tLink('seventhSlideLink'),
      stackPosition: 'left',
    },
  ];

  const renderStaticSlides = (staticSlides: any[]): ReactElement => (
    <>
      {staticSlides.map(slide => (
        <Link
          href={slide.link}
          noTabbing
          key={slide.id}
          className={`discover-section-wrapper ${slide.stackPosition}`}
        >
          <div className="ctg-image">
            <picture>
              <source
                data-srcset={slide.imageSrc}
                media="(max-width: 768px)"
                srcSet={slide.imageSrc}
              />
              <img
                data-src={slide.imageSrc}
                alt={t('alt')}
                src={slide.imageSrc}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="720"
                height="720"
              />
            </picture>
          </div>
          <div className={`stack ${slide.stackPosition}`}>
            <h3>{slide.title}</h3>
            <p className="desktop-only">{slide.description}</p>
            <span className="btn base-btn btn-text">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
        </Link>
      ))}
    </>
  );

  return (
    <section id="hp-discover" className="hp-section discover-section">
      <div className="hp-banner" data-event-name="bloc_interact" data-bloc-name={t('title')}>
        <div className="desktop-only">
          <h2>
            {t('discoverSectionQuote')}
            <span>{t('discoverSectionQuoteSpan')}</span>
          </h2>
          <div className="clearfix discover-section-links">{renderStaticSlides(slides)}</div>
        </div>
        <div className="tagline stack">
          <h2>
            {t('taglineTitle')}
            <span>{t('taglineTitleSpan')}</span>
          </h2>
          <p>{t('taglineDescription')}</p>
        </div>
      </div>
    </section>
  );
};

export default DiscoverSection;
